import { FeatureIds, IUserCompanyRoles } from "@redbelly-tokeniser/mystake-common-sdk";
import { isAvererWalletSelected } from "../walletProvider";

export const canShowEmbeddedWalletMenu = (
  features: Record<string, boolean>,
  userCompanyRoles: IUserCompanyRoles
): boolean =>
  isAvererWalletSelected() &&
  features[FeatureIds.NON_CUSTODIAL_WALLET_ENABLED] === true &&
  userCompanyRoles.isAdmin === true;
